<template lang="pug">
    MatchMedia(v-slot='{ screenSM }')
        .home-page
            online-users-control.home-page__online-users(v-if="!screenSM")

            tabs-control.home-page__tabs(v-if="!screenSM" v-model="tab" :tabs="tabs")

            .home-page__content-wrap
                .home-page__left(v-if="screenSM || showPosts")
                    post-feed-control
                .home-page__right(v-if="screenSM || showSuggestions")
                    online-users-control.home-page__online-users(v-if="screenSM")
                    video-suggestions-control
                    profile-suggestions-control
</template>

<script>
import { MatchMedia } from 'vue-component-media-queries'

export default {
    name: 'home-page',

    components: {
        MatchMedia,
    },

    data() {
        return {
            tab: 'posts',
            mobile: false,
        }
    },

    computed: {
        tabs() {
            return [
                { label: 'Posts', name: 'posts' },
                { label: 'Suggestions', name: 'suggestions' },
            ]
        },

        showPosts() {
            return this.tab == 'posts'
        },
        showSuggestions() {
            return this.tab == 'suggestions'
        }
    },
}
</script>